import CustomerUserManagement from '@/features/users/customer-user-management/CustomerUserManagement';
import { useCustomerSiteOptions } from '@/queries/customers';
import { useUsersBySite } from '@/queries/users';
import useAuth from '@/shared/context/auth-context';
import { useQueryClient } from '@tanstack/react-query';
import { FunctionComponent, ReactElement } from 'react';
import { useParams } from 'react-router-dom';

const UsersPage: FunctionComponent = (): ReactElement => {
	const queryClient = useQueryClient();
	const { user } = useAuth();

	const { siteId } = useParams();

	const { data: sitesOptions } = useCustomerSiteOptions(user?.customerId);

	const { queryKey: useUsersQueryKey, query: useUsersQuery } = useUsersBySite(siteId, {
		limit: 99999,
	});

	const refetchCustomerUsers = () => {
		/* eslint-disable @typescript-eslint/no-floating-promises */
		queryClient.invalidateQueries(useUsersQueryKey);
	};

	return (
		<CustomerUserManagement
			query={useUsersQuery}
			invalidateQuery={refetchCustomerUsers}
			siteOptions={sitesOptions}
			customer={user?.customer}
			exportUsersSiteId={siteId}
		/>
	);
};

export default UsersPage;
